import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { apiService } from "service/ApiService";
import { notify } from "service/NotificationService";

// components

import CreateRecordButton from "components/Buttons/CreateRecordButton";
import RowEditButton from "components/Buttons/RowEditButton";
import { Col, Row } from "react-bootstrap";
import Pagination from "components/Pagination/Pagination";

export default function CompaniesTable({ color }) {
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);

  const [dataPerPage, setDataPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const handleError = (error) => notify("Error", error);

  const fetchData = async () => {
    try {
      const dataResponse = await apiService.get(`api/companies`);
      setData(dataResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAlert(error.message);
      handleError(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const startIndex = currentPage * dataPerPage;
  const paginatedData = data.slice(startIndex, startIndex + dataPerPage);

  return (
    <>
      {alert}
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative px-4 max-w-full flex-grow flex-1">
              <h3 className={"font-semibold text-lg " + (color === "light" ? "text-blueGray-700" : "text-white")}>Companies</h3>
            </div>
            <div className="relative w-full max-w-full flex-grow flex-1 float-right">
              <CreateRecordButton route={"/admin/company"} />
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                  Name
                </th>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                  Vat Number
                </th>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                  Branch
                </th>
                <th className="px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"></th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((company, index) => (
                <tr key={index}>
                  <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-left flex items-center">
                    <p>{company.name}</p>
                  </th>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4">{company.vat_number}</td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4">{company.branch}</td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-right">
                    <Row>
                      <Col md="12" className="w-1/3 pr-4 float-right">
                        <RowEditButton uri={`/admin/company/${company._id}`} />
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
        <Pagination
            totalRows={data.length}
            dataPerPage={dataPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setDataPerPage={setDataPerPage}
          />
      </div>
    </>
  );
}

CompaniesTable.defaultProps = {
  color: "light",
};

CompaniesTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
